var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"mask-fade","appear":""}},[_c('div',{ref:"mask",class:{ 'can-touch': _vm.canTouch },attrs:{"id":"mask"},on:{"touchstart":_vm.click}})])
}
var staticRenderFns = []

export { render, staticRenderFns }